import { DELETE_PORTOFOLIO_START } from '../../types';

export const delete_portofolio = (payload) => ({
  type: DELETE_PORTOFOLIO_START,
  payload,
});
